import React, { useEffect, useState, useCallback, useRef } from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"
import { getFinanceCostCenterList } from "../../../services/Settings/dropdown"

function ucfirst(str) {
  return str ? str.charAt(0).toUpperCase() + str.slice(1) : ""
}

// Custom debounce hook
function useDebounce(callback, delay) {
  const timeoutRef = useRef(null)

  const debouncedFunction = (...args) => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current)
    timeoutRef.current = setTimeout(() => {
      callback(...args)
    }, delay)
  }

  return debouncedFunction
}

const FinCostCenterLi = ({
  control,
  name,
  onSelectChange,
  placeholder,
  disabled,
  excludeIdOne = false,
  type,
}) => {
  const [options, setOptions] = useState([])
  const [inputValue, setInputValue] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [page, setPage] = useState(1)
  const [hasMore, setHasMore] = useState(true)

  const fetchOptions = useCallback(async (searchText = "", pageNo = 1) => {
    setIsLoading(true)
    try {
      const params = new URLSearchParams({
        searchText: searchText,
        page: pageNo.toString(),
        type: type ? type : "",
      }).toString()

      const res = await getFinanceCostCenterList({ params })

      const responseData = res || {}
      let items = responseData?.data || []

      if (excludeIdOne) {
        items = items.filter(item => item.id !== 1)
      }

      const newOptions = items.map(dta => ({
        label: dta?.name ? ucfirst(dta.name) : "Unnamed",
        value: dta.id,
        ...dta,
      }))

      setOptions(prev => (pageNo === 1 ? newOptions : [...prev, ...newOptions]))

      setHasMore(responseData?.currentPage < responseData?.last_page)
    } catch (err) {
      console.error("Failed to load options", err)
    } finally {
      setIsLoading(false)
    }
  }, [])

  const debouncedFetch = useDebounce(val => {
    setPage(1)
    fetchOptions(val, 1)
  }, 500)

  useEffect(() => {
    fetchOptions("", 1)
  }, [fetchOptions])

  const handleInputChange = value => {
    setInputValue(value)
    debouncedFetch(value)
    return value
  }

  const handleScrollBottom = () => {
    if (hasMore && !isLoading) {
      const nextPage = page + 1
      setPage(nextPage)
      fetchOptions(inputValue, nextPage)
    }
  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, ref, value } }) => (
        <Select
          ref={ref}
          value={value}
          options={options}
          onChange={e => {
            onChange(e)
            if (onSelectChange) onSelectChange(e)
          }}
          // placeholder={placeholder || "Select"}
          placeholder={
            <div className="css-placeholder">{placeholder || "Select"}</div>
          }
          isDisabled={disabled}
          isLoading={isLoading}
          onMenuScrollToBottom={handleScrollBottom}
          onInputChange={handleInputChange}
          inputValue={inputValue}
          classNamePrefix="react-select"
          className="elevate-dropdown"
          menuPortalTarget={document.body}
          noOptionsMessage={() => "No results found"}
          styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
        />
      )}
    />
  )
}

export default FinCostCenterLi
